/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FreeTextbooksSubtopicViewQuestionsQueryVariables = {
    subtopicId: string;
};
export type FreeTextbooksSubtopicViewQuestionsQueryResponse = {
    readonly subtopic: {
        readonly id: string;
        readonly problemContents: ReadonlyArray<{
            readonly id: string;
            readonly estimatedCompletionTime: number;
            readonly problemTemplateId: string;
            readonly isStaticQuestion: boolean;
            readonly " $fragmentRefs": FragmentRefs<"ProblemItemFreeTextbooks_problemContent">;
        }>;
    } | null;
};
export type FreeTextbooksSubtopicViewQuestionsQuery = {
    readonly response: FreeTextbooksSubtopicViewQuestionsQueryResponse;
    readonly variables: FreeTextbooksSubtopicViewQuestionsQueryVariables;
};



/*
query FreeTextbooksSubtopicViewQuestionsQuery(
  $subtopicId: ID!
) {
  subtopic(id: $subtopicId) {
    id
    problemContents(limit: 4) {
      id
      estimatedCompletionTime
      problemTemplateId
      isStaticQuestion
      ...ProblemItemFreeTextbooks_problemContent
    }
  }
}

fragment PreviewProblemAttachment_problemContent on ProblemContent {
  attachment
}

fragment PreviewProblemAttributes_problemContent on ProblemContent {
  difficultyLevel
  estimatedCompletionTime
}

fragment PreviewProblemInstruction_problemContent on ProblemContent {
  instruction
}

fragment PreviewProblemSubproblem_subproblem on SubproblemContent {
  instruction
  subproblemType
  ...SubproblemInput_subproblem
}

fragment ProblemItemFreeTextbooks_problemContent on ProblemContent {
  id
  attachment
  difficultyLevel
  estimatedCompletionTime
  ...PreviewProblemInstruction_problemContent
  ...PreviewProblemAttachment_problemContent
  ...PreviewProblemAttributes_problemContent
  subproblems {
    instruction
    subproblemType
    ...PreviewProblemSubproblem_subproblem
    id
  }
}

fragment SubproblemInput_subproblem on SubproblemContent {
  subproblemType
  initialInputConfiguration {
    __typename
    ... on LatexAnswerConfig {
      template
    }
    ... on MultipleChoiceConfig {
      options {
        optionContent
        optionKey
      }
    }
    ... on NumberLineConfig {
      mode
      unit
      start
      end
      minorTicks
      majorTicks
      numberLineValues {
        lowerBound {
          inclusive
          value
        }
        substatus
        upperBound {
          inclusive
          value
        }
      }
    }
    ... on LegacyGraphPlotConfig {
      requestDatum
    }
    ... on HistogramConfig {
      doesDrawBars
      doesDrawLines
      dragHandleAlignment
      hasGapBetweenBars
      mainLabel
      histogramValues {
        title
        value
      }
      xAxisLabel
      yAxisLabel
      yIncrement
      yMax
      yMin
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subtopicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "subtopicId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 4
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedCompletionTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemTemplateId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStaticQuestion",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instruction",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inclusive",
    "storageKey": null
  },
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreeTextbooksSubtopicViewQuestionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookSubtopic",
        "kind": "LinkedField",
        "name": "subtopic",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ProblemContent",
            "kind": "LinkedField",
            "name": "problemContents",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProblemItemFreeTextbooks_problemContent"
              }
            ],
            "storageKey": "problemContents(limit:4)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreeTextbooksSubtopicViewQuestionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookSubtopic",
        "kind": "LinkedField",
        "name": "subtopic",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ProblemContent",
            "kind": "LinkedField",
            "name": "problemContents",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attachment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "difficultyLevel",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SubproblemContent",
                "kind": "LinkedField",
                "name": "subproblems",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subproblemType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "initialInputConfiguration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "template",
                            "storageKey": null
                          }
                        ],
                        "type": "LatexAnswerConfig",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MultipleChoiceOption",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "optionContent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "optionKey",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MultipleChoiceConfig",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unit",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "start",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "end",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minorTicks",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "majorTicks",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NumberLineSegment",
                            "kind": "LinkedField",
                            "name": "numberLineValues",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NumberLinePoint",
                                "kind": "LinkedField",
                                "name": "lowerBound",
                                "plural": false,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "substatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NumberLinePoint",
                                "kind": "LinkedField",
                                "name": "upperBound",
                                "plural": false,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "NumberLineConfig",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "requestDatum",
                            "storageKey": null
                          }
                        ],
                        "type": "LegacyGraphPlotConfig",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "doesDrawBars",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "doesDrawLines",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dragHandleAlignment",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasGapBetweenBars",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HistogramDatum",
                            "kind": "LinkedField",
                            "name": "histogramValues",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "xAxisLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yAxisLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yIncrement",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yMax",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yMin",
                            "storageKey": null
                          }
                        ],
                        "type": "HistogramConfig",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "problemContents(limit:4)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae2761a9cfcf1c88131053552f2603bc",
    "id": null,
    "metadata": {},
    "name": "FreeTextbooksSubtopicViewQuestionsQuery",
    "operationKind": "query",
    "text": "query FreeTextbooksSubtopicViewQuestionsQuery(\n  $subtopicId: ID!\n) {\n  subtopic(id: $subtopicId) {\n    id\n    problemContents(limit: 4) {\n      id\n      estimatedCompletionTime\n      problemTemplateId\n      isStaticQuestion\n      ...ProblemItemFreeTextbooks_problemContent\n    }\n  }\n}\n\nfragment PreviewProblemAttachment_problemContent on ProblemContent {\n  attachment\n}\n\nfragment PreviewProblemAttributes_problemContent on ProblemContent {\n  difficultyLevel\n  estimatedCompletionTime\n}\n\nfragment PreviewProblemInstruction_problemContent on ProblemContent {\n  instruction\n}\n\nfragment PreviewProblemSubproblem_subproblem on SubproblemContent {\n  instruction\n  subproblemType\n  ...SubproblemInput_subproblem\n}\n\nfragment ProblemItemFreeTextbooks_problemContent on ProblemContent {\n  id\n  attachment\n  difficultyLevel\n  estimatedCompletionTime\n  ...PreviewProblemInstruction_problemContent\n  ...PreviewProblemAttachment_problemContent\n  ...PreviewProblemAttributes_problemContent\n  subproblems {\n    instruction\n    subproblemType\n    ...PreviewProblemSubproblem_subproblem\n    id\n  }\n}\n\nfragment SubproblemInput_subproblem on SubproblemContent {\n  subproblemType\n  initialInputConfiguration {\n    __typename\n    ... on LatexAnswerConfig {\n      template\n    }\n    ... on MultipleChoiceConfig {\n      options {\n        optionContent\n        optionKey\n      }\n    }\n    ... on NumberLineConfig {\n      mode\n      unit\n      start\n      end\n      minorTicks\n      majorTicks\n      numberLineValues {\n        lowerBound {\n          inclusive\n          value\n        }\n        substatus\n        upperBound {\n          inclusive\n          value\n        }\n      }\n    }\n    ... on LegacyGraphPlotConfig {\n      requestDatum\n    }\n    ... on HistogramConfig {\n      doesDrawBars\n      doesDrawLines\n      dragHandleAlignment\n      hasGapBetweenBars\n      mainLabel\n      histogramValues {\n        title\n        value\n      }\n      xAxisLabel\n      yAxisLabel\n      yIncrement\n      yMax\n      yMin\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8d8b4e4678a81e6d932f8e3a40d3d823';
export default node;
